import { useIntl, useStaticUrls, ModalDescriptor, ModalsBuilder } from 'platform-components';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useRouteMatch } from 'react-router';

import { HowToStartModal } from 'common.components/how-to-start-modal/how-to-start-modal';
import { getShouldShowHowToStartModal } from 'common.components/how-to-start-modal/selectors';
import * as lessonViewSelectors from 'common.components/lesson-view.store/selectors';
import { PersonalDataModal } from 'common.components/personal-data-modal/personal-data-modal';
import { getShouldShowPersonalDataModal } from 'common.components/personal-data-modal/selectors';
import { getIsTeamBuilderActive } from 'common.components/team-builder/selectors';
import { getIsTeacherFromMes } from 'utils/external-lms/external-lms';
import { getSubjectFromPath, getTeamIdFromPath } from 'utils/path';

import { LibraryUpdatesModal } from '../library-updates-modal/library-updates-modal';
import { getShouldLibraryUpdatesModal } from '../library-updates-modal/selectors';
import { NewSubjectModal } from '../new-subject-modal/new-subject-modal';
import { getShouldShowNewSubjectModal } from '../new-subject-modal/selectors';
import { NewYearModal } from '../new-year-modal/new-year-modal';
import { getShouldShowNewYearModal } from '../new-year-modal/selectors';
import { getShouldShowSpecCourseModalOffer } from '../spec-course-modal-offer/selectors';
import { SpecCourseModalOffer } from '../spec-course-modal-offer/spec-course-modal-offer';
import { getShouldShowUMKModal } from '../umk-modal/selectors';
import { UMKModal } from '../umk-modal/umk-modal';

export const TeacherModalsBuilder = () => {
    const intl = useIntl();
    const teamId = getTeamIdFromPath();
    const subject = getSubjectFromPath();
    const staticUrls = useStaticUrls();
    const isLibrary = useRouteMatch(staticUrls.labClassLibrary);
    const isLessons = useRouteMatch(staticUrls.labClassLessons);
    const isTeamsSettings = useRouteMatch(staticUrls.labClass);
    const isSpecCourseLessonsUrl = useRouteMatch(staticUrls.labClassSpecCourseStub);
    const isLessonViewModalOpened = useSelector(lessonViewSelectors.getShouldShowModal);
    const isTeamBuilderActive = useSelector(getIsTeamBuilderActive);
    const { search } = useLocation();

    const isTeacherFromMes = getIsTeacherFromMes(search);

    const modals: Array<ModalDescriptor> = [
        {
            component: <HowToStartModal />,
            ownDisplayCondition: useSelector((store) => getShouldShowHowToStartModal(store, { intl })),
        },
        {
            component: <PersonalDataModal />,
            ownDisplayCondition: useSelector(getShouldShowPersonalDataModal),
        },
        {
            component: <LibraryUpdatesModal />,
            ownDisplayCondition: useSelector((store) =>
                getShouldLibraryUpdatesModal(store, { classId: teamId, subject })
            ),
            contextDisplayCondition: Boolean(isLibrary),
        },
        {
            component: <SpecCourseModalOffer />,
            ownDisplayCondition: useSelector(getShouldShowSpecCourseModalOffer),
            contextDisplayCondition: Boolean(isSpecCourseLessonsUrl),
        },
        {
            component: <NewYearModal />,
            ownDisplayCondition: useSelector((store) => getShouldShowNewYearModal(store, { classId: teamId })),
            contextDisplayCondition: !isTeamsSettings,
        },
        {
            component: <UMKModal />,
            ownDisplayCondition: useSelector((store) =>
                // @ts-ignore
                getShouldShowUMKModal(store, { classId: teamId, intl, subject })
            ),
            contextDisplayCondition: Boolean(isLibrary),
        },
        {
            component: <NewSubjectModal />,
            ownDisplayCondition: useSelector(getShouldShowNewSubjectModal),
            contextDisplayCondition: Boolean(isLibrary) || Boolean(isLessons),
        },
    ];

    if (isTeacherFromMes || isLessonViewModalOpened || isTeamBuilderActive) {
        return null;
    }

    return <ModalsBuilder modals={modals} />;
};
